import { render, staticRenderFns } from "./CrisisSurvivalIcon.vue?vue&type=template&id=b4993020&scoped=true"
import script from "./CrisisSurvivalIcon.vue?vue&type=script&lang=js"
export * from "./CrisisSurvivalIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4993020",
  null
  
)

export default component.exports